export enum CancelStates {
    welcome,
    finish
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/CancelStates.ts